export default __webpack_public_path__ + "static/media/manage_system.ccdf4c24.svg";